<div class="search-block">
  <div class="container">
    <div>
      <div id="home_nav" class="row">
        <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
          <ol class="breadcrumb loginMenu">
            <li class="breadcrumb-item" style="align-items: center;float:right;">
              <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation()">Home</a>
            </li>
            <li class="breadcrumb-item active">My Help Center</li>
          </ol>
        </div>
        <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
          <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
            [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
            (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
            (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()"
            placeholder="{{searchTextboxNote}}" aria-label="Type here to Search an Article" title="{{searchTextboxHover}}">
          </ng-autocomplete>
          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.name"></a>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound>
            No Suggestion...
          </ng-template>
          <span class="input-group-append" (click)="search(searchKey)">
            <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-create-ticket *ngIf="checkCaseModalInHelpCenter" (checkIsCaseModalOpenInHelpCenter)="checkIsCaseModalOpen($event)">
</app-create-ticket>
<header class="helpCenterHeader">
  <nav class="navbar navbar-expand-lg navbar-dark pink scrolling-navbar" role="navigation">
    <a class="navbar-brand">
    </a>
    <div class="container" style="padding: 0px;">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav nav-pills">
          <ng-container *ngIf="myHelpCenterConfigurationOptionLabel">
            <li class="nav-item" *ngFor="let helpCenterConfig of myHelpCenterConfigurationOptionLabel.slice(0,1);let i = index">
              <button class="btn" *ngIf="!helpCenterConfig.labelEnabler">
                <a class="nav-link active" style="cursor: pointer;"
                  (click)="navigationLink(i)">{{helpCenterConfig.labelText}}</a> </button>
            </li>
          </ng-container>
          <li class="nav-item">
            <button class="btn" *ngIf="showOnSelfHelp==true">
              <a class="nav-link active" style="cursor: pointer;" (click)='handleTrackerNavigation()'>Tracker</a> 
            </button>
          </li>
        </ul>
      </div>
    </div>

  </nav>


</header>
<br>
<button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == false" type="button" (click)="openChat()"  class="btn btn-primary">LIVE CHAT</button>
<button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == true" type="button"  class="btn btn-primary">LIVE CHAT</button>

<div class="container" *ngIf=this.helpCenterCases>
  <div *ngIf="this.helpCenterLabel==false">
    <div *ngFor="let hp of header?.headerHyperLink;let i = index">
      <button type="button" style="float: right;" rounded="true" class="btn btn-primary btn" *ngIf="i == 1"
        id=“help-center-title-btn” (click)="createCaseLink()">
        {{hp.linkText}}</button></div>
    <div id=“help-center-title” style="font-size: 24px;font-family: Arial,Helvetica,sans-serif;">
      {{this.ticketListLabel}}</div>
    <br>
    <div [innerHTML]="this.listSizeNotes" *ngIf="this.listSizeNotes!=''"
      style="font-size: 18px;font-family: Arial,Helvetica,sans-serif;">{{this.listSizeNotes}}</div>
    <div>
      <br>
      <table class="table-headed table-striped">
        <thead>
          <tr>
            <th class="text-left" style="padding-left: 5px;">Case Number</th>
            <th class="text-left">Title</th>
            <th class="text-left">Last Updated</th>
            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody *ngIf="helpCenterCases!=''">
          <tr *ngFor="let helpCase of sort('updatedDate')">
            <td
              style="font-size: 14px;font-family: Arial,Helvetica Neue,Helvetica,sans-serif;cursor:pointer;padding-left: 5px">
              <span>
                <button type="button"  (click)="viewCase(helpCase.ticket_number.split('-')[1])"  data-bs-toggle="modal" data-bs-target="#viewModel" class="astext">{{helpCase.ticket_number}}</button>
              </span>
              <span
                *ngIf="helpCase.status.name=='Closed' || helpCase.status.name=='RESOLVED'||helpCase.status.name=='Solution Suggested'||helpCase.status.name=='L2: Solution Suggested'||helpCase.status.name=='L2: Closed'">
                <button type="button" class="btn surveyButton" *ngIf="this.isDefaultSurveyPresent || this.defaultCustomSurvey==true" aria-label="surveyButton"
                  (click)="handleSurveyNavigation(helpCase.ticket_number)"><img src='shp/assets/images/survey.png' aria-label="surveyImage"></button>
              </span>
            </td>
            <td style="font-size: 14px;font-family: Arial,Helvetica Neue,Helvetica,sans-serif">{{helpCase.summary}}
            </td>
            <td style="font-size: 14px;font-family: Arial,Helvetica Neue,Helvetica,sans-serif">
              {{helpCase.date_updated | date:'yyyy-MM-dd  hh:mm a'}}</td>
            <td class="status {{helpCase.status.extensions}}"><span>{{helpCase.status.name}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="helpCenterCases==''"
      style="text-align: center;font-size: 18px;font-family: Arial,Helvetica Neue,Helvetica,sans-serif;">
      <br>
      There are no cases to list
    </div>
    <br>
    <br>
  </div>
</div>

<!-- -------------------------------------------------------------CASE VIEW ---------------------------------------------------------------------->

<div class="modal fade" id="viewModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" style="background-color: dodgerblue">
        <h5 class="modal-title" id="viewModelLabel" style="color: white;">{{i18n._value['shp.myHelpCenter.viewCase']}}
        </h5>
        <button #closebutton type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close" ></button>
      </div>
      <div class="modal-body">
        <div class="container ">
          <form #chatform="ngForm" class="form_class" *ngIf=ticket>
            <div class="row">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.caseNumber']}}</div>
              <div class="form-group col-md-9">{{ticket.ticket_number}}</div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.status']}}</div>
              <div class="form-group col-md-9">{{ticket.status.name}}</div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.dateCreated']}}</div>
              <div class="form-group col-md-9">
                {{ticket.date_created | date:'yyy-MM-dd hh:mm a '}}
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.dateUpdated']}}</div>
              <div class="form-group col-md-9">
                {{ticket.date_updated| date:'yyy-MM-dd hh:mm a '}}
              </div>
            </div>
            <div *ngFor="let ticketField of ticket.values">
              <div class="row">
                <div class="form-group col-md-3">{{ticketField.label}}:</div>
                <div *ngIf="ticketField.type!='LONGSTRING'" class="form-group col-md-9"
                  ngClass="ticketField.type=='PLAINSTRING'?'plain-text-line-break':''">{{ticketField.value}}</div>
                <div *ngIf="ticketField.type=='LONGSTRING'" class="form-group col-md-9">
                  <p [innerHTML]="ticketField.value"></p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.attachment']}}</div>
              <div class="form-group col-md-9">
                <p *ngFor="let attachments of ticket.attachment">
                  <a href="/api/v1/{{instId}}/file/{{attachments.id}}" title="{{attachments.titleName}}" target="blank"
                    style='text-decoration: underline;'>{{attachments.name}}</a>
                </p>
              </div>
            </div>
            <div class="row" *ngIf="chatTranscriptAttachments.length > 0">
              <div class="form-group col-md-3">{{i18n._value['shp.MyHelpCenter.chatTranscriptAttachment']}}</div>
              <div class="form-group col-md-9">
                <p *ngFor="let chatTranscriptAttachment of chatTranscriptAttachments">
                  <a href="/api/v1/{{instId}}/file/{{chatTranscriptAttachment.id}}" target="_blank"
                    style='text-decoration: underline;'>{{chatTranscriptAttachment.name}}</a>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">{{i18n._value['shp.MyHelpCenter.solution']}}</div>
              <div class="form-group col-md-9" style="overflow: auto;">
                <p [innerHTML]=history></p>
              </div>
            </div>
            <div class="form-row" *ngIf="action != null && action != ''&& action.length > 0">
              <div class="form-group col-md-12">{{i18n._value['shp.MyHelpCenter.comments']}}<span
                  class="text-danger">*</span></div>
              <div class="form-group col-md-12">
                <textarea class="form-control input-sm" [(ngModel)]="comment" name="comment" [required]="true">
        </textarea>
              </div>
            </div>
            <div *ngIf="action != null && action != ''&& action.length > 0">
              <button class="file-upload-button">
                <input type="file" #fileInput name="file" (click)="fileInput.value = null"
                  (change)="handleFileInput($event)" multiple
                  accept=".txt,.doc,.docx, .xls, .xlsx, .pdf, .png, .gif, .jpeg, .jpg, .mp3, .mp4, .mov, .avi, .log, .csv, .ppt, .pptx, .p7s, .tif, .tiff, .rtf, .xml, .eml, .msg, .wav" />
              </button>
              <div class="fieldName" style="color: black;">{{i18n._value['shp.MyHelpCenter.max']}}
                <i class="fa fa-info" style="border-radius: 50%;"
                  title="{{i18n._value['shp.MyHelpCenter.view.fileFormate']}}"></i>
              </div>
              <span class="fieldName" *ngIf="fileProgress">{{i18n._value['shp.case.fileSize']}}</span>
              <span class="fieldName" *ngIf="UploadingFile" title="{{UploadedFileName}}">{{uploadedFileLength}}
                files</span>
              <br>
              <div class="progress" *ngIf="this.status">
                <br>
                <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                  [style.width.%]="this.progress">
                  {{this.progress}}%
                </div>
              </div>
              <div *ngIf="files!=''">
                <br>
                <table class="table-headed table-striped">
                  <thead>
                    <tr>
                      <th class="text-left" style="padding-left: 5px;">Name</th>
                      <th class="text-left">Size</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of files">
                      <td id="size_class">{{file.name}}</td>
                      <td>{{file.size/1024 | number:'.1-2' }} KB</td>
                      <a (click)="remove(file)">
                        <i class="fa fa-trash"
                          style="color:red;cursor:pointer; padding-top:20px;padding-left: 25px;"></i>
                      </a>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
              <div class="fieldName" *ngIf="regexFile" style="color:red;">
                {{i18n._value['upload.invalid.file.name']}}
              </div>
              <div class="fieldName" *ngIf="UploadFailedMessage" style="color:red;">
                {{i18n._value['shp.case.file.length']}}
              </div>
              <div class="fieldName" *ngIf="!duplicateFiles" style="color:red;">
                {{i18n._value['shp.case.duplicate.file']}}
              </div>
              <div class="fieldName" *ngIf="sizeExceededMessage" style="color:red;">
                {{i18n._value['shp.case.error.size']}}
              </div>

              <div class="fieldName" *ngIf="UploadedFileName && UploadedFileName.length >100" style="color:red;">
                {{i18n._value['upload.error.name.exceed']}}
              </div>
            </div>

            <div class="modal-footer d-flex justify-content-end">
              <button type="button" [disabled]="!chatform.valid" *ngFor="let actions of action" id="{{actions.id}}"
                class="btn btn-primary m-1" (click)="executeAction(actions.id)"> {{actions.external_label}}</button>
              <button type="button" class="btn btn-secondary m-1" data-bs-dismiss="modal" aria-label="Close" 
                >{{i18n._value['shp.MyHelpCenter.close']}} </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isNotAuthorised" style="display: flex;align-items: center;justify-content: center;">
  <p>Sorry, you are not allowed to view the cases.</p>
</div>